import randomString from 'randomstring';

export const generateCodeChallenge = async (): Promise<string> => {
  const code_verifier = randomString.generate(128);
  const encodedData = new TextEncoder().encode(code_verifier);
  const digest = await window.crypto.subtle.digest('SHA-256', encodedData);
  const base64Digest = base64Encode(digest);
  return base64Digest.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

export const base64Encode = (buffer): string => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const length = bytes.length;
  for (let i = 0; i < length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};
